import { Link as ScrollLink } from 'react-scroll';
import { Link, useNavigate } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

import logo from '../moodmealslogo.png';
import facebook from "../assets/icons/Facebook.png";
import instagram from "../assets/icons/Instagram.png";
import twitter from "../assets/icons/TwitterX.png";
import back from "../assets/icons/back-arrow.png"
import user1 from "../assets/icons/User.png";

import OrderCompletedModal from './OrderCompletedModal';
import '../styles/CheckoutPage.css';

const CheckoutPage=({user,orderSummary,onLogout,logoutSuccess,setLogoutSuccess})=>{

    const [cart,setCart]=useState([]);
    const [order,setOrder]=useState({
        order_total: parseFloat(orderSummary.totalPrice.toFixed(2)),
        order_subtotal: parseFloat(orderSummary.subTotal.toFixed(2)),
        order_sf: 'Free',
        order_discounts: parseFloat(orderSummary.discount.toFixed(2)),
        order_promocode: orderSummary.holdpromoCode,
        order_tax: parseFloat(orderSummary.tax.toFixed(2)),
        order_method: 'Cash on Delivery'
    });

    const [message,setMessage]=useState("");
    const [showModal,setShowModal]=useState(false);
    const [orderSuccess, setOrderSuccess]=useState(false);

    const [paymentMethod,setPaymentMethod]=useState(false);
    const [isLoading,setIsLoading]=useState(true);
    const [isDropdownOpen,setIsDropdownOpen]=useState(false);
    const navigate=useNavigate();
    const dropdownRef=useRef(null);

    useEffect(()=>{
        setTimeout(()=>{
        setIsLoading(false);
        },2000);
    },[]);
    
    useEffect(()=>{
        if(logoutSuccess){
            setIsLoading(true);
            setTimeout(() => {
                setIsLoading(false);
                setLogoutSuccess(false);
                navigate('/');
            }, 2000);
        }
    },[logoutSuccess,navigate,setLogoutSuccess]);

    useEffect(()=>{
        axios.get(`/api/user/getCartItems`,{withCredentials:true})
        .then(res=>{
            setCart(res.data.cart);
        })
        .catch(err=>{
            console.error('No active session:',err);
        })
    },[]);

    const handleCreateOrder=(e)=>{
        e.preventDefault();
        if(user===null){
            navigate('/login');
            return;
        }
        axios.post(`/api/user/new/order`,order,{withCredentials: true})
        .then(res=>{
            setOrder({
                order_total: parseFloat(orderSummary.totalPrice.toFixed(2)),
                order_subtotal: parseFloat(orderSummary.subTotal.toFixed(2)),
                order_sf: 'Free',
                order_discounts: parseFloat(orderSummary.discount.toFixed(2)),
                order_promocode: orderSummary.holdpromoCode,
                order_tax: parseFloat(orderSummary.tax.toFixed(2)),
                order_method: 'Cash on Delivery'
            });
            setMessage("Your Order Placed Successfully!");
            setShowModal(true);
            setOrderSuccess(true);
        })
        .catch(err=>{
            console.log("Error adding this item:",err);
        });
    };

    const viewOrders=()=>{
        setShowModal(false);
        navigate('/your-orders');
    }

    const closeModal=()=>{
        setShowModal(false);
        if(orderSuccess){
            setIsLoading(true);
            setTimeout(()=>{
                setIsLoading(false);
                navigate('/');
            },1500);
        }
    };

    const toggleUser=()=>{
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleClickOutside=(e)=>{
        if(dropdownRef.current&&!dropdownRef.current.contains(e.target)){
            setIsDropdownOpen(false);
        }
    };

    useEffect(()=>{
        document.addEventListener('mousedown',handleClickOutside);
        return()=>{
            document.removeEventListener('mousedown',handleClickOutside);
        };
    },[]);

    return (
        <>
        {isLoading?(
            <div className="loadingContainer">
                <img src={logo} alt="Loading..." className="moodmeals-loading-logo"/>
            </div>
        ):(
        <>
            {/* <!-- Cart Section --> */}
            <main className="checkout-bg-wrapper">
                {/* <!-- Header Section --> */}
                <header className="checkout-header">
                    <div className="checkout-back">
                    <Link to="/your-cart"><img src={back} className="checkout-back-btn" alt="Back"/> Return to Cart</Link>
                    </div>
                    <div className="user-profile">
                    <div className="user-bg">
                        <h5>{user.firstname} {user.lastname}</h5>
                    </div>
                    <div className="checkoutDropdown">
                        <img src={user?user.avatar:user1} alt="#User Avatar" loading="lazy" onClick={toggleUser}/>
                        {isDropdownOpen&&(
                            <div className="checkout-dropdownMenu" ref={dropdownRef}>
                                {user?(
                                    <>
                                    <p className="checkout-dropdownItem">Welcome, {user.firstname}</p>
                                    <Link to="/profile" className="checkout-dropdownItem">Profile</Link>
                                    <Link to="/setting" className="checkout-dropdownItem">Setting</Link>
                                    <Link onClick={onLogout} className="checkout-dropdownItem">Log Out</Link>
                                    </>
                                ):(
                                    <>
                                    <Link to="/login" className="checkout-dropdownItem">Login</Link>
                                    <Link to="/register" className="checkout-dropdownItem">Register</Link>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                    </div>
                </header>
                <main className="checkout-main">
                    <section className="your-checkout">
                        {paymentMethod?(
                            <>
                                <div className='c-link'>
                                    <button className='checkout-link' onClick={()=>setPaymentMethod(false)}>Payment Info</button>{'>'}
                                    <button className='checkout-link' onClick={()=>setPaymentMethod(true)}>Review + Purchase</button>
                                </div>
                                <div className='checkout-order'>
                                    <div className='order-cart-list'>
                                        <div className="checkout-cart-lists">
                                            {cart.map((element,index)=>(
                                                <div className="checkout-cart-item">
                                                    <img src={element.cart_img} className="checkout-item-picture" alt={`Cart ${index}`}/>
                                                    <div className="checkout-item-info">
                                                        <div className="checkout-item-name">
                                                            <h3>{element.cart_name}</h3>
                                                        </div>
                                                        <div className="checkout-price">
                                                            <h1>₱ {element.cart_itemprice}</h1>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <hr/>
                                        <div className="checkout-order-summary">
                                            <p>Subtotal: ₱ {parseFloat(orderSummary.subTotal.toFixed(2))}</p>
                                            <hr/>
                                            <p>Total: ₱ {parseFloat(orderSummary.totalPrice.toFixed(2))} (discounts + tax included)</p>
                                        </div>
                                        <button className='place-order-btn' onClick={(e)=>handleCreateOrder(e)}>Place Order</button>
                                    </div>
                                    <div className="checkout-delivery-details">
                                        <h3>Delivery Details:</h3>
                                        <ul>
                                            <li>Orders placed by Monday noon will be delivered by Friday.</li>
                                            <li>Free shipping for orders over ₱2,783.</li>
                                            <li>Currently delivering to Manila, Philippines.</li>
                                        </ul>
                                    </div>
                                </div>
                            </>
                        ):(
                            <>  
                                <div className='c-link'>
                                    <button className='checkout-link' onClick={()=>setPaymentMethod(false)}>Payment Info</button>{'>'}
                                    <button className='checkout-link' onClick={()=>setPaymentMethod(true)}>Review + Purchase</button>
                                </div>
                                <h1>Payment Method</h1>
                                <div className='payment-method'>
                                    <div className='payment-details'>
                                        <form>
                                            <h4>Please select a payment method</h4>
                                            <select className='checkout-glass-select' name='payment-option' value={order.order_method} onChange={(e)=>setOrder({...order, order_method: e.target.value})}>
                                                <option>Cash on Delivery</option>
                                                <option>Master Card</option>
                                                <option>Visa</option>
                                                <option>Paypal</option>
                                                <option>Gcash</option>
                                            </select>
                                            <p>If your billing address is not in Philippines, please <a href='/'>set your store region preference</a></p>
                                            <div className='payment-btn'>
                                                <button onClick={()=>setPaymentMethod(true)}>Continue</button>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="checkout-order-summary">
                                        <div className="checkout-os-total"> 
                                            <h3>Total Order </h3>
                                            <p className="checkout-total">₱ {parseFloat(orderSummary.totalPrice.toFixed(2))}</p>
                                        </div>
                                        <p>Total Items: {orderSummary.totalItems}</p>
                                        <p>Subtotal: ₱ {parseFloat(orderSummary.subTotal.toFixed(2))}</p>
                                        <p>Shipping: Free</p>
                                        <p>Discounts: -₱ {parseFloat(orderSummary.discount.toFixed(2))} (Promo: {orderSummary.holdpromoCode})</p>
                                        <p>Tax: ₱ {parseFloat(orderSummary.tax.toFixed(2))}</p>
                                    </div>
                                </div>
                            </>
                        )}
                    </section>
                </main>
            </main>

            {/* <!-- Footer Section --> */}
            <footer className="checkout-footer">
            <h3 className="checkout-get-in-touch">Get in Touch</h3>
            <div className="checkout-footer-content">
                <div className="checkout-footer-section">
                    <h3>Customer Support</h3>
                    <p>Email: <a href="/">support@moodmeals.com</a></p>
                    <p>Phone: <a href="/">+63 (800) 123-4567</a></p>
                    <p>Live Chat: Available Monday to Friday, 9 AM - 6 PM (EST)</p>
                    <h3>General Inquiries:</h3>
                    <p>For general questions, feedback, or press inquiries, please email: <a href="/">info@moodmeals.com</a></p>
                    <h3>Partnership Opportunities:</h3>
                    <p>Interested in partnering with MoodMeals? Reach out to: <a href="/">partnerships@moodmeals.com</a></p>
                </div>
                <div className="checkout-footer-section">
                    <h3>Quick Links</h3>
                    <ul>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/shop">Shop</Link></li>
                    <li><Link to={{pathname:"/",state:{section:"recipes"}}}>Recipes</Link></li>
                    <li><Link to={{pathname:"/",state:{section:"community"}}}>Community</Link></li>
                    <li><Link to={{pathname:"/",state:{section:"about-us"}}}>About Us</Link></li>
                    <li><ScrollLink to="contact" smooth={true} duration={500}>Contact</ScrollLink></li>
                    <li><Link to={{pathname:"/",state:{Element:"blog"}}}>Blog</Link></li>
                    </ul>
                </div>
                <div className="checkout-footer-section">
                    <h3>Customer Services</h3>
                    <ul>
                    <li><a href="#contact-us">Contact Us</a></li>
                    <li><a href="#faq">FAQ</a></li>
                    <li><a href="#shipping&returns">Shipping & Returns</a></li>
                    <li><a href="#terms&condition">Terms & Condition</a></li>
                    <li><a href="#privacy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
            <div className="checkout-soc-med">
                <div className="checkout-app-wrapper">
                <img className="app" src={facebook} alt="facebook"/>
                <img className="app" src={instagram} alt="instagram"/>
                <img className="app" src={twitter} alt="twitter"/>
                <p>Mailing Address: MoodMeals HQ 123 Wellness Lane, Healthy City, MA 10001, Philippines</p>
                </div>
                <div className="checkout-copyright">
                    <p>&copy; 2024 MoodMeals. All rights reserved.</p>
                </div>
            </div>
            </footer>
            {showModal&&<OrderCompletedModal message={message} onClose={closeModal} onView={viewOrders}/>}
        </>
        )}
        </>
    )
}

export default CheckoutPage;